import React, { useEffect, useRef, useState } from 'react';
import './ReportViewer.less';

import * as FlexmonsterReact from 'react-flexmonster';
import { Link, useHistory } from "react-router-dom";
import Input, { Button, Icon } from "semantic-ui-react";
import { API_PATHS, LOCAL_STORAGE_KEYS, PAGE_ROUTES } from "../../constants";
import { standardGetFetchOptions, standardHeadFetchOptions, standardPostFetchOptions } from "../../utils/FetchUtils";
import NewReportModal from "../NewReportModal";
import DatePicker from "react-datepicker/dist/react-datepicker";
import { TextArea } from "semantic-ui-react";
import { getModuleIdFromPath, has } from "../../utils/GeneralUtils";
import SaveReportModal from "../SaveReportModal";
import ConfirmationModal from "../ConfirmationModal";
import CampaignDisclosureDateModal from '../CampaignDisclosureDateModal';

function ReportViewer( props ) {
    const { data } = props.location;
    let reportData = data;

    // Get startDate and endDate from query params if available
    let startDateParam = null;
    let endDateParam = null;
    if (props.location && props.location.startDate && props.location.endDate) {
        startDateParam = props.location.startDate;
        endDateParam = props.location.endDate;
    }

    const enhanceMappingForTimezone = (mapping) => {
        if (!mapping || !mapping.rows) return mapping;
        
        const enhancedMapping = { ...mapping };
        
        // Find date fields and add timezone conversion
        Object.keys(enhancedMapping.rows).forEach(key => {
            const field = enhancedMapping.rows[key];
            if (field && (field.type === 'date' || field.type === 'datetime' || key.toLowerCase().includes('date'))) {
                enhancedMapping.rows[key] = {
                    ...field,
                    type: 'date',
                    // Add custom formatting for user timezone
                    format: field.format || 'MM/dd/yyyy'
                };
            }
        });
        
        return enhancedMapping;
    };
    
    const normalizeReportBody = (body) => {
        if (!body) return body;
        if (typeof body === 'string') {
            try {
                return JSON.parse(body);
            } catch (e) {
                console.error('Failed to parse reportBody', e);
                return null;
            }
        }
        return body;
    };
    // if ( reportData )
    //     localStorage.setItem( "reportViewerData", JSON.stringify( reportData ) );
    // else
    //     reportData = JSON.parse( localStorage.getItem( "reportViewerData" ) );

    const [ clickCount, setClickCount ] = useState( 1 );
    const [ reportBody, setReportBody ] = useState( reportData ? normalizeReportBody(reportData.reportBody) : null );
    const [ isReadyToLoad, setIsReadyToLoad ] = useState( true );
    const [ overwriteFilename,setOverwriteFilename ] = useState( "" );

    const [ campaignModalState, setCampaignModalState ] = useState( { 
                showModal: false, 
                selectedReport: null,
            } );
        
    let openCampaignModal = ( report ) => setCampaignModalState( { showModal: true, selectedReport: report } );
    let closeCampaignModal = () => setCampaignModalState( { showModal: false, selectedReport: null } );

    const pivotRef  = useRef( "pivot" );

    let moduleId = getModuleIdFromPath();


    var initialFilterValue = [];

    const setupFilters = function() {
        // var dataset = reportData.dataset;
        if ( reportData && reportData.dataset ) {
            let dataset = reportData.dataset;
            // console.log( "dataset is defined." );
            if ( dataset.filters ) {
                // console.log( "Dataset and Filters are defined." )
                let filters = dataset.filters;
                for ( let i = 0; i < filters.length; i++ ) {
                    let filter = filters[ i ];

                    // If the filters passed in don't have values already, set up the defaults.
                    if ( !filter.filterValue ) {
                        let defaultFunc = new Function( filter.defaultValue );
                        let defaultValue = defaultFunc();
                        initialFilterValue[ i ] = defaultValue;

                        // console.log( "defaultValue: " + defaultValue );

                        filter.filterValue = defaultValue; //new Date( initialFilterValue ).toISOString().substring( 0, 10 );

                    } else {
                        initialFilterValue[ i ] = filter.filterValue;
                    }
                }
            }
        }
    }
    const [ filterValues, setFilterValues ] = useState( initialFilterValue );
    
    function getQueryStringFromFilters( filters ) {
        if( !filters || filters.length === 0 ) {
            // Append the current time to avoid cache.
            return "?" + ( Math.trunc( new Date().getTime() / 1000 ) );
        }

        let queryString = "?";

        for ( let i = 0; i < filters.length; i++ ) {
            let f = filters[ i ];
            if ( i > 0 )
                queryString += "&";

            queryString += f.fieldName;

            if ( f.filterValue ) {
                queryString += "=";

                if( f.type === 'Date' ) {
                    queryString += f.filterValue.toISOString().substring( 0, 10 );
                } else {
                    queryString += f.filterValue;
                }
            }
        }

        queryString += "&" + ( Math.trunc( new Date().getTime() / 1000 ) );

        return queryString;
    }

    const refreshReportData = function ( reportBodyParam ) {
        let flexmonster = pivotRef.current.flexmonster;
        if (!flexmonster)
            return;

        if (!(reportBody || reportBodyParam))
            return;

        let queryString = '';
        // If startDate and endDate are available in query params, use them
        if (startDateParam && endDateParam) {
            queryString = `?startDate=${encodeURIComponent(startDateParam)}&endDate=${encodeURIComponent(endDateParam)}`;
        } else {
            queryString = getQueryStringFromFilters(reportData.dataset.filters);
        }

        // Use flexmonster.getReport().slice.flatOrder for selected fields
        let fieldsValue = null;
        if (flexmonster) {
            const reportObj = flexmonster.getReport();
            if (reportObj && reportObj.slice && Array.isArray(reportObj.slice.flatOrder)) {
                fieldsValue = reportObj.slice.flatOrder.join(',');
            }
        }
        if (fieldsValue) {
            if (queryString.includes('?')) {
                queryString += `&fields=${encodeURIComponent(fieldsValue)}`;
            } else {
                queryString = `?fields=${encodeURIComponent(fieldsValue)}`;
            }
        }

        // Always append a unique _reload parameter to force Flexmonster to reload
        if (queryString.includes('?')) {
            queryString += `&_reload=${Date.now()}`;
        } else {
            queryString = `?_reload=${Date.now()}`;
        }

        let flexmonsterReport = flexmonster.getReport();

        if (!(flexmonsterReport && flexmonsterReport.dataSource)) {
            if (!reportBody) {
                return;
            }
            flexmonsterReport = normalizeReportBody(reportBody);
            if (!flexmonsterReport)
                flexmonsterReport = normalizeReportBody(reportBodyParam);
        }

        let dataSource = {
            requestHeaders: {
                "Authorization": "Bearer " + localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN)
            },
            filename: process.env.REACT_APP_CONNECTOR_HOST + reportData.dataset.path + queryString,
            mapping: enhanceMappingForTimezone(flexmonsterReport.dataSource ? flexmonsterReport.dataSource.mapping : undefined)
        };

        flexmonsterReport.dataSource = dataSource;
        flexmonster.setReport(flexmonsterReport);
    };


    if ( reportData ) {
        // console.log( " Report data was passed in. " );
        setupFilters();
        if ( reportData.reportBody ) {
            // console.log(" !!! This report had a body !!! ");

            // refreshReportData();
            // let queryString = getQueryStringFromFilters( reportData.dataset.filters );
            //
            // reportData.reportBody.dataSource.requestHeaders = {
            //     "Authorization": "Bearer " + localStorage.getItem( LOCAL_STORAGE_KEYS.AUTH_TOKEN )
            // };
            // reportData.reportBody.dataSource.filename = process.env.REACT_APP_CONNECTOR_HOST + dataset.path + queryString;
        }
    }



    const handleNameClick = function ( event ) {
        // console.log( clickCount );
        setClickCount( clickCount + 1 );
        if ( !( clickCount % 10 ) ) {
            // alert( "Ten clicks." );
            let showExtraToolTabs = localStorage.getItem( "extraToolTabs" );
            if ( !showExtraToolTabs || showExtraToolTabs !== 'true' )
                localStorage.setItem( "extraToolTabs", true );
            else
                localStorage.setItem( "extraToolTabs", false );
        }
    }

    function fetchReportBody() {
        let reportPath = process.env.REACT_APP_CONNECTOR_HOST + API_PATHS.REPORTS + "/" + reportData.reportId;

        // console.log( "Report Path:" + reportPath );

        fetch( reportPath, standardGetFetchOptions() )
            .then( res => {
                //return res.text();
                //console.log( "response is:" + res.text() )
                return res.json();
            } )
            .then( result => {
                    // console.log( "Results loaded." );
                    // console.log( result );

                    delete result.datasource;

                    setReportBody( result );
                    setupFilters();
                    // refreshReportData( result );
                    // let flexmonster = pivotRef.current.flexmonster;
                    // result.dataSource.requestHeaders = {
                    //     "Authorization": "Bearer " + localStorage.getItem( LOCAL_STORAGE_KEYS.AUTH_TOKEN )
                    // };
                    //
                    // let queryString = getQueryStringFromFilters( reportData.dataset.filters );
                    // console.log( result );
                    // delete result.dataSource.filename;  // = "";
                    // console.log( result );
                    // flexmonster.setReport( result );
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                ( error ) => {
                    console.log( error );
                    setReportBody( null );
                    //setError(error);
                }
            );
    }

    const handleSaveClick = function() {
        setShowSaveModal( true );
    }

    const handleNameModalSave = function( reportName, skipExistCheck ) {
        // console.log( reportName + "<-- report name")

        if( !skipExistCheck ) {
            let fullPath = process.env.REACT_APP_CONNECTOR_HOST + PAGE_ROUTES.REPORTS + "/" + reportName + "?moduleId=" + getModuleIdFromPath();

            let options = standardHeadFetchOptions();

            fetch( fullPath, options )
                .then(res=> {
                    if ( res.status === 404 ) {
                        // console.log( "404 - means report with that name doesn't already exist" )
                        handleNameModalSave( reportName, true );
                    } else if( res.status === 200 ) {
                        // console.log( "200 - means this report name already exists.  overwrite?")
                        setOverwriteFilename( reportName );
                    } else {
                        console.log( "Error saving report." );
                    }

                });

            return;
        }

        // Clear overwrite filename modal if open.
        setOverwriteFilename( "" );

        reportData.reportName = reportName;
        let flexmonster = pivotRef.current.flexmonster;
        //let reportName = prompt( "Report Name: ", "" );

        let reportBody = flexmonster.getReport()

        let reportInfoToSend = JSON.parse( JSON.stringify( reportData ) );
        reportInfoToSend.reportBody = JSON.stringify( reportBody );

        reportInfoToSend.reportName = reportName;
        reportInfoToSend.moduleId = localStorage.getItem( LOCAL_STORAGE_KEYS.MODULE_ID );

        let fullPath = process.env.REACT_APP_CONNECTOR_HOST + PAGE_ROUTES.REPORTS;

        let options = standardPostFetchOptions();
        options.headers["Content-Type"] = "application/json";
        options.body = JSON.stringify( reportInfoToSend );

        fetch( fullPath, options )
            .then(res=> {
                if( res.ok )
                    setShowSaveModal( false );
                else
                    console.log( "Error saving report." );
            })
        ;
    }

    // console.log( props.match.params.id );

    const[ showNewReport, setShowNewReportModal ] = useState( false );
    const[ showSaveModal, setShowSaveModal] = useState( false );
    const[ reportFilename, setReportFilename ] = useState( reportData ? reportData.filename : "" );

    const handleNewReport = function () {
        setShowNewReportModal( true );
    };

    // const refreshReport = function ( reportBodyParam ) {
    //     console.log("Refreshing report.");
    //     console.log( reportBody );
    //     console.log( reportBodyParam );
    //     if(! ( reportBody || reportBodyParam ) )
    //         return;
    //
    //     let queryString = getQueryStringFromFilters( reportData.dataset.filters );
    //     let flexmonster = pivotRef.current.flexmonster;
    //     let report = flexmonster.getReport();
    //
    //     if( ! ( report && report.dataSource ) ) {
    //         console.log( "report is null" );
    //         if( !reportBody ) {
    //             console.log( "reportBody is null." );
    //             return;
    //         }
    //         report = reportBody;
    //
    //         if( !report )
    //             report = reportBodyParam;
    //     }
    //     report.dataSource.requestHeaders = {
    //         "Authorization": "Bearer " + localStorage.getItem( LOCAL_STORAGE_KEYS.AUTH_TOKEN )
    //     };
    //     //delete report.dataSource.filename;
    //     report.dataSource.filename = process.env.REACT_APP_CONNECTOR_HOST + dataset.path + queryString;
    //     console.log( report.dataSource.filename );
    //     flexmonster.setReport( report );
    // };

    const handleNewReportClose = function () {
        setShowNewReportModal( false );
    };

    let history = useHistory();

    const handleOnGo = function ( data ) {
        // console.log( "handleOnGo called with data: " + JSON.stringify( data ) );
        setShowNewReportModal( false );
        
        if (isCampaignDisclosuresReport(data.dataset.descriptiveName)) {
            openCampaignModal(data);
            return false;
        } else {
            history.push({
            pathname: PAGE_ROUTES.REPORTS + "/New Report",
            data: data
            });
        }
    };

    const handleSaveModalClose = function (  ) {
        // console.log( "handleSaveModalClose called." );
        setShowSaveModal( false );
    };

    const handleDateFilterChanged = function ( date, filterItem, idx, e ) {
        // Because the date pickers are wrapped in a semantic-ui label, we have to "preventDefault()" so that
        // the click event does not trigger a re-open.  Default behavior of the datapicker is to close the popup
        // after the date has been selected.
        e.preventDefault();

        // console.log( date );
        // console.log( filterItem );
        //filterItem.filterValue = date.toISOString().substring( 0, 10 );
        filterItem.filterValue = date;
        // console.log( filterItem );
        var newArray = [ ...filterValues ];
        newArray[ idx ] = date;
        setFilterValues( newArray );
    }

    const handleTextFilterChanged = function( data, filterItem, idx ) {
        filterItem.filterValue = data.target.value;

        var newArray = [ ...filterValues ];
        newArray[ idx ] = data.target.value;
        setFilterValues( newArray );
    }

    const handleCampaignDateSelection = function ( startDate, endDate ) {
        // Format date as yyyy-MM-dd HH:mm:ss for the API
        const formatDateTimeForAPI = (date) => {
            const pad = (n) => n.toString().padStart(2, '0');
            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
        };

        const startDateStr = formatDateTimeForAPI(startDate);
        const endDateStr = formatDateTimeForAPI(endDate);

        // Navigate to the report with the data object similar to the Link component
        history.push({
            pathname: `${PAGE_ROUTES.REPORTS}/New Report`,
            data: campaignModalState.selectedReport,
            startDate: startDateStr,
            endDate: endDateStr
        });

        closeCampaignModal();
    };
        
    const isCampaignDisclosuresReport = function ( reportName ) {
        if (!reportName) return false;
        const lower = reportName.toLowerCase();
        return lower.includes("coi disclosee not started disclosure") || lower.includes("coi disclosee started disclosure");
    };

    useEffect(()=>{
        console.log( "using effect" );
        if( !reportBody ) {
            console.log( "reportBody is null" );
            if( fetchReportBody === null )
            {
                console.log( "fetchReportBody is null" );
            }
            fetchReportBody();
        }
    },[]);

    useEffect(() => {
        if (reportBody) {
            refreshReportData();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reportBody]);

    return (
        <div className="ReportViewer">
            <div className="header">
                <div className="names">
                    {reportData &&
                    <div className="report-name" onClick={handleNameClick}>{reportData.reportName}</div>
                    }
                    {/*{reportData && reportData.dataset &&*/}
                    {/*<div className="dataset-name" onClick={handleNameClick}>{reportData.dataset.descriptiveName}</div>*/}
                    {/*}*/}
                </div>
                {reportData.dataset && reportData.dataset.filters &&
                        reportData.dataset.filters.map( ( filter, idx ) =>
                            <div key={idx} className="filter-and-label-block" >
                                <div className="filter-label">{filter.descriptiveName}<span style={{color:"#b31200"}}>*</span></div>
                                <div className="filter-values-block">
                                {filter.type === "Date" &&
                                <label className="date-picker-with-icon" >
                                    <div className="date-picker-icon" ><Icon name="calendar alternate outline"/></div>
                                    <div className="date-picker-alignment"><DatePicker onChange={ ( date, e ) => handleDateFilterChanged( date, filter, idx, e )}
                                                selected={filterValues[ idx ]} />
                                    </div>

                                </label>
                                }

                                {filter.type === "Text" &&
                                <input type="text"  placeholder={"Enter " + filter.descriptiveName} onChange={ ( e, data ) => handleTextFilterChanged( e, filter, idx )}
                                       value={filterValues[ idx ] } ></input>
                                }
                                </div>
                            </div>
                        )
                    // </div>
                }
                <Button  disabled={!isReadyToLoad} primary={isReadyToLoad} onClick={refreshReportData} style={{float:"left", marginTop:"0.15em"}}><Icon name='refresh' style={{marginRight:"0px",marginLeft:"0px"}} ></Icon></Button>
                <div className="button-block" style={{float:"right",marginTop:"0.15em"}} >
                    <Button primary onClick={handleSaveClick} style={{float:"right"}}>Save</Button>
                    <Button primary onClick={handleNewReport} style={{float:"right"}} ><Icon name='plus'></Icon>New Report</Button>
                </div>
            </div>

            {reportData == null
                ? <div><h1></h1></div>
                : <FlexmonsterReact.Pivot
                    ref={pivotRef}
                    //report={reportBody}
                    toolbar={true}
                    beforetoolbarcreated={toolbar => {
                        var tabs = toolbar.getTabs();
                        toolbar.getTabs = function () {
                            let showExtraToolTabs = localStorage.getItem( "extraToolTabs" );
                            if ( !showExtraToolTabs || showExtraToolTabs !== 'true' ) {
                                delete tabs[ 2 ];
                                delete tabs[ 1 ];
                                delete tabs[ 0 ];

                                delete tabs[ tabs.length - 1 ];
                                delete tabs[ tabs.length - 1 ];
                                delete tabs[ tabs.length - 1 ];
                            }

                            return tabs;
                        };
                        console.log( "beforetoolbarcreated" )
                    }}
                    onFieldsListApplied={refreshReportData}
                    dataProcessed={(data) => {
                        // Process data to convert dates to user's timezone
                        if (data && data.data && Array.isArray(data.data)) {
                            data.data.forEach(row => {
                                Object.keys(row).forEach(key => {
                                    if (row[key] && typeof row[key] === 'string') {
                                        let decodedValue = row[key]
                                            .replace(/&sol;/g, '/');
                                        const dateRegex = /^\d{1,2}\/\d{1,2}\/\d{4}(\s+\d{1,2}:\d{2}(:\d{2})?)?$|^\d{4}-\d{2}-\d{2}(\s+\d{1,2}:\d{2}(:\d{2})?)?$|^\d{2}-\d{2}-\d{4}(\s+\d{1,2}:\d{2}(:\d{2})?)?$/;
                                        if (dateRegex.test(decodedValue)) {
                                            let date;
                                            if (decodedValue.includes('/')) {
                                                const parts = decodedValue.split(' ');
                                                const datePart = parts[0];
                                                const timePart = parts[1] || '';
                                                
                                                const [day, month, year] = datePart.split('/');
                                                // Force UTC interpretation to ensure consistent timezone alignment
                                                let dateString = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
                                                if (timePart) {
                                                    dateString += 'T' + timePart + 'Z'; // Add Z to force UTC interpretation
                                                }
                                                date = new Date(dateString);
                                            } else {
                                                // For ISO format dates, ensure they're treated as UTC if no timezone specified
                                                let dateString = decodedValue;
                                                if (!dateString.includes('Z') && !dateString.includes('+') && !dateString.includes('-', 10)) {
                                                    dateString += 'Z'; // Force UTC if no timezone specified
                                                }
                                                date = new Date(dateString);
                                            }
                                            
                                            if (!isNaN(date.getTime())) {
                                                // Convert to user's local timezone with 24-hour format
                                                const hasTime = decodedValue.includes(':');
                                                if (hasTime) {
                                                    row[key] = date.toLocaleDateString() + ' ' + date.toLocaleTimeString('en-GB', { hour12: false });
                                                } else {
                                                    row[key] = date.toLocaleDateString();
                                                }
                                            }
                                        }
                                    }
                                });
                            });
                        }
                    }}
                    customizeCell={(cell, data) => {
                        // Handle timezone conversion for date cells
                        if (data && data.type === 'value' && cell && cell.text) {
                            let decodedText = cell.text
                                .replace(/&sol;/g, '/');                            
                            const dateRegex = /^\d{1,2}\/\d{1,2}\/\d{4}(\s+\d{1,2}:\d{2}(:\d{2})?)?$|^\d{4}-\d{2}-\d{2}(\s+\d{1,2}:\d{2}(:\d{2})?)?$|^\d{2}-\d{2}-\d{4}(\s+\d{1,2}:\d{2}(:\d{2})?)?$/;
                            if (dateRegex.test(decodedText)) {
                                let date;
                                if (decodedText.includes('/')) {
                                    const parts = decodedText.split(' ');
                                    const datePart = parts[0];
                                    const timePart = parts[1] || '';
                                    
                                    const [day, month, year] = datePart.split('/');
                                    // Force UTC interpretation to ensure consistent timezone alignment
                                    let dateString = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
                                    if (timePart) {
                                        dateString += 'T' + timePart + 'Z'; // Add Z to force UTC interpretation
                                    }
                                    date = new Date(dateString);
                                } else {
                                    // For ISO format dates, ensure they're treated as UTC if no timezone specified
                                    let dateString = decodedText;
                                    if (!dateString.includes('Z') && !dateString.includes('+') && !dateString.includes('-', 10)) {
                                        dateString += 'Z'; // Force UTC if no timezone specified
                                    }
                                    date = new Date(dateString);
                                }
                                
                                if (!isNaN(date.getTime())) {
                                    // Convert to user's timezone and format appropriately with 24-hour format
                                    const hasTime = decodedText.includes(':');
                                    if (hasTime) {
                                        cell.text = date.toLocaleDateString() + ' ' + date.toLocaleTimeString('en-GB', { hour12: false });
                                    } else {
                                        cell.text = date.toLocaleDateString();
                                    }
                                }
                            }
                        }
                    }}
                    componentFolder="https://cdn.flexmonster.com/" 
                    width="100%"
                    licenseKey={process.env.REACT_APP_FM_LICENSE}
                />
            }

            { showNewReport &&
            <NewReportModal open={showNewReport} onClose={handleNewReportClose} onGo={handleOnGo} />
            }
            { showSaveModal &&
            <SaveReportModal  suggestedFileName={reportFilename} open={showSaveModal} onCloseClicked={handleSaveModalClose} onGo={(f)=> { handleNameModalSave(f);} } />
            }
            { overwriteFilename &&
                <ConfirmationModal
                    icon={"exclamation triangle"}
                    style={{ modal: {} }}
                    open={overwriteFilename}
                    onCancel={ ()=> setOverwriteFilename( "" ) }
                    onConfirm={ ()=> handleNameModalSave( overwriteFilename, true ) }
                    title={"A report with this name already exists."}
                    content={"Do you want to continue and overwrite the existing report?"}
                />
            }
            {campaignModalState.showModal &&<CampaignDisclosureDateModal
                open={campaignModalState.showModal}
                onCancel={closeCampaignModal}
                onContinue={handleCampaignDateSelection}
                title={
                    campaignModalState.selectedReport &&
                    campaignModalState.selectedReport.dataset?.descriptiveName &&
                    campaignModalState.selectedReport.dataset?.descriptiveName.toLowerCase().includes("not started")
                    ? "Campaign Disclosures - Not Started"
                    : "Campaign Disclosures - Started"
                }
            />}
        </div> );
}

export default ReportViewer;
